import { BotList, NovelList, StoryList } from '@/components/icon';
import { AuthType } from '@/const/auth';
import { MenuConfig } from '@/interface/menu';
import { EDITOR, PIC_BOOK_IMAGE_LIST, PIC_BOOK_TEXT_LIST, UGC_BOT_LIST, UGC_NOVEL_LIST, UGC_STORY_LIST } from '@/router/const';

export const MENU_CREATE = [
  {
    path: EDITOR,
    label: '创建故事',
    icon: 'palette',
    type: [AuthType.CMS, AuthType.UGC],
  },
  {
    path: `${UGC_BOT_LIST}?mode=add`,
    label: '创建角色',
    icon: 'face-retouching',
    type: [AuthType.CMS, AuthType.UGC],
  },
];

export const WOA_MENU_LIST: MenuConfig[] = [
  {
    path: UGC_STORY_LIST,
    label: '故事列表',
    icon: 'component-divider-vertical',
    svg: <StoryList />,
  },
  {
    path: UGC_BOT_LIST,
    label: '角色列表',
    icon: 'usergroup',
    svg: <BotList />,
  },
  {
    path: UGC_NOVEL_LIST,
    label: '灵感列表',
    icon: 'filter3',
    svg: <NovelList />,
  },
];

export const UGC_MENU_LIST: MenuConfig[] = [
  {
    path: UGC_STORY_LIST,
    label: '故事列表',
    icon: 'component-divider-vertical',
    svg: <StoryList />,
  },
  {
    path: UGC_BOT_LIST,
    label: '角色列表',
    icon: 'usergroup',
    svg: <BotList />,
  },
];

export const UGC_BOOK_LIST: MenuConfig[] = [
  {
    path: PIC_BOOK_IMAGE_LIST,
    label: '图生绘本列表',
    icon: 'usergroup',
    svg: <BotList />,
    type: [AuthType.CMS, AuthType.UGC],
  },
  {
    path: PIC_BOOK_TEXT_LIST,
    label: '文生绘本列表',
    icon: 'component-divider-vertical',
    svg: <StoryList />,
    type: [AuthType.CMS, AuthType.UGC],
  },
];
